export default [
  {
    path: '/Clinic-Department',
    name: 'Clinic-Department',
    component: () => import('@/views/Clinic/Clinic.vue'),
  },
  {
    path: '/Clinic/patient/preview/:id',
    name: 'Clinic-patient-preview',
    component: () => import('@/views/Clinic/ClinicPatientCard.vue'),
  },
  {
    path: '/patient/full',
    name: 'patient-full',
    component: () => import('@/views/PatientReport/patientReportMain.vue'),
  },
  {
    path: '/patient/full',
    name: 'patient-full',
    component: () => import('@/views/PatientReport/patientReportMain.vue'),
  },
  {
    path: '/patient/full/preview/:id',
    name: 'patient-full-preview',
    component: () => import('@/views/PatientReport/patientReportPreview.vue'),
  },

  {
    path: '/examination-form',
    name: 'examination-form',
    component: () => import('@/views/Clinic/ExaminationForm.vue'),
  },
  {
    path: '/anesthetia-form',
    name: 'anesthetia-form',
    component: () => import('@/views/Clinic/AnesthetiaForm.vue'),
  },
  {
    path: '/operative-form',
    name: 'operative-form',
    component: () => import('@/views/Clinic/OperativeNotesForm.vue'),
  },
];
